<template>
  <div @contextmenu.prevent="handler($event)"
       :id="this.id"
       class="sitebuilder-element-container big-is-receiver"
       element="AccordionGroupComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)"
       :style="style()"
       v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)"
                             v-bind:h="parseInt(internal_config.height) ? parseInt(internal_config.height) : 60"
                             @resizing="onResize"
                             :draggable="false" :enable-native-drag="true">

      <sync-drag :target="this"/>

      <options-element-bar ref="optionsBar" :elem="this"
                           name='ct-component-AccordionGroupComponent'>
        <img src="static/images/icons/add.svg"
             v-tooltip="{content:$t('ct-add-accordion'),  class: 'tooltip-custom'}"
             class="svg-icon normal-action"
             @click="addAccordion"/>
      </options-element-bar>
      <div class="container-accordion-group" v-bind:style="{
        borderRadius: radius,
        background: background,
        border : border,
        boxShadow: boxShadow,
        paddingTop : paddingTop,
        paddingLeft : paddingLeft,
        paddingRight : paddingRight,
        paddingBottom : paddingBottom,
        }">
        <component v-for="(element,index) in elements" :is="element.name" :config="element.config" :key="index"
                   :id="element.id" :height_start="index" :preview="preview" :childs="element.childs"
                   @setCallbackChangeDevice="setCallbackChangeDevice"></component>
      </div>
    </vue-draggable-resizable>


    <resources ref="resourcesData"></resources>
  </div>
</template>

<script>

  import Data from './Model';
  import Model from "./Model";
  import Resources from './Resources.vue';
  import OptionsElementBar from "../../OptionsElementBar";
  import MixinComponents from "../../../../../js/mixins/MixinComponents";

  export default {
    name: 'AccordionGroupComponent',
    props: ['config', 'childs', 'device', 'id', 'preview'],
    mixins: [MixinComponents],
    components: {
      OptionsElementBar,
      Resources,
      Model
    },
    computed: {
      paddingTop() {
        return this.internal_config.paddingTopContainer;
      },
      paddingLeft() {
        return this.internal_config.paddingLeftContainer;
      },
      paddingRight() {
        return this.internal_config.paddingRightContainer;
      },
      paddingBottom() {
        return this.internal_config.paddingBottomContainer;
      },
  // bg-color bg-image position/bg-size bg-repeat bg-origin
      background() {
        let bg = this.internal_config.backgroundColor;

        if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {

          bg += ' url("' + this.internal_config.backgroundImage + '")';
          bg += ' ' + this.internal_config.backgroundPosition;
          bg += ' / ' + this.internal_config.backgroundSize;
          bg += ' ' + this.internal_config.backgroundRepeat;
          bg += ' ' + this.internal_config.backgroundOrigin;
        }

        return bg;
      },

    },
    data() {
      return Data.data();
    },
    watch: {
      'internal_config': {
        deep: true,
        handler(value) {
          this.$eventHub.setValueElementConfig(this.id, value);
          this.$eventPointer.log(this.id, value);
        }
      },
    },
    methods: {
      changeOrderPanel(elem, idx) {

        let id = elem.$el.id,
          sibling = idx === 1 ? document.getElementById(id).nextSibling : document.getElementById(id).previousSibling;

        if (sibling === null) {
          return true;
        }

        this.$root.$emit('changeOrderElementsInside', this.id, id, sibling.id, idx);

      },
      addAccordion() {

        if (typeof this.$eventHub.getElement(this.id) === 'undefined') {
          let vm = this;
          setTimeout(() => {
            vm.addAccordion();
          }, 1000)
        } else {
          this.$root.$emit('createBaseElement', 'AccordionComponent', {}, this.id);
        }
      },
      onResize(x, y, width, height) {
        this.internal_config.width = width + 'px';
        this.internal_config.height = height + 'px';

        this.$refs.resourcesData.setValuesData(this);
      },

      showResources() {
        return this.$refs.resourcesData.getValuesData();
      },
      style() {
        return `left:  ${this.internal_config.left};
                  top: ${this.internal_config.top};
                  padding-top: ${this.internal_config.paddingTop};
                  padding-left: ${this.internal_config.paddingLeft};
                  padding-right: ${this.internal_config.paddingRight};
                  padding-bottom: ${this.internal_config.paddingBottom};
                  z-index: ${this.internal_config.zIndex};
                  width: ${this.internal_config.width};
                  max-width: ${this.internal_config.maxWidth};
                  margin: 0 auto;`;
      },
      setCallbackChangeDevice(values) {
        this.$emit('setCallbackChangeDevice', values);
      },
      build() {
        let vm = this;
        setTimeout(() => {
          if (vm.$el.querySelectorAll('[element]').length === 0) {
            vm.addAccordion();
          }

        }, 3000);
      },
      sendNewChilds() {

        let vm = this;

        setTimeout(() => {
          // console.log(vm.elements);
          vm.$eventPointer.changePointerState(true);
          vm.$eventPointer.logChilds(vm.id, vm.elements);
          setTimeout(() => {
            vm.$eventPointer.changePointerState(true);
          }, 500)
        }, 1000)
      },
    },
    mounted() {

      let device, childs, id, config;
      ({device, childs, id, config} = this.$props);

      if (typeof config.backgroundColor === 'undefined') {
        config.backgroundColor = '#FFFFFF';
      }
      this.internal_config = config;
      this.device = device;

      if (typeof childs === 'undefined') {
        childs = [];
        this.internal_config.childs = [];
      }

      if (typeof id !== 'undefined') {
        this.id = id;
      }

      let objIds = [];
      $('[id]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] == this && parseInt(this.id))
          objIds.push(this.id);
      });

      if (objIds.includes(this.id)) {
        let newId = Date.now() + parseInt(Math.random() * 10000);
        this.id = newId;

        childs.forEach((el, index) => {
          try {
            childs[index].config.parent_id = newId;
          } catch (e) {
          }
        });

        this.$refs.elem.id = newId;
      }

      this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));

      // this.internal_config = window.mergeRecursive(this.props, this.$props.config);
      let internal_config = window.mergeRecursive(this.props, this.$props.config);
      this.internal_config = {...internal_config, ...this.internal_config};

      this.$root.$on('setConfigElement', (id, obj) => {
        if (this.id == id) {
          this.config = obj;
          this.internal_config = obj;
        }
      });
      // this.$root.$on('removeAccordion', () => {
      //   if (this.$el.querySelectorAll('[element]').length === 0) {
      //     this.addAccordion();
      //   }
      // });

      this.$root.$on('setChildsObj', (id) => {
        if (this.id == id) {

          this.$eventPointer.logChilds(this.id, this.elements);

          let childsHub = this.$eventHub.getChilds(this.id);

          this.config.childs = childsHub;
          this.internal_config.childs = childsHub;

          this.elements = {};
          this.$nextTick(() => {
            this.elements = childsHub.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
            this.componentKey += 1;

            this.$nextTick(() => {
              this.sendNewChilds();
              this.$root.$emit('activeSort');
              this.$refs.resourcesData.setValuesData(this);
            });
          });
        }
      });

      this.$root.$on('setChildsUndoRedo', (id, childs) => {
        if (this.id == id) {
          this.$eventHub.setChilds(this.id, childs);

          this.config.childs = childs;
          this.internal_config.childs = childs;

          this.elements = {};
          this.$nextTick(() => {
            this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
            this.componentKey += 1;
          });
        }
      });

      this.build();

      this.$refs.resourcesData.setValuesData(this);
    }
  }

</script>
<style lang="scss" scoped>

  .card-body {
    position: relative;
  }

  .sitebuilder-element-container {

    .vdr {
      height: unset !important;
      padding: 15px !important;
      box-sizing: content-box !important;
    }
  }

  [data-preview="true"] {
    .container-accordion-group {
      overflow: hidden;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/AccordionElement/AccordionGroup/AccordionGroup.vue